import { gql } from '@apollo/client'

import { DISPLAY_FRAGMENT } from './DisplayFragment'
import { DISPLAY_SNAPSHOT_WITH_IMAGE_BOXES_FRAGMENT } from './DisplaySnapshotWithImageBoxesFragment'

export const RESTOCK_FRAGMENT = gql`
  fragment Restock on Restock {
    id
    created
    display {
      ...Display
    }
    displaySnapshots {
      ...DisplaySnapshotWithImageBoxes
    }
  }
  ${DISPLAY_FRAGMENT}
  ${DISPLAY_SNAPSHOT_WITH_IMAGE_BOXES_FRAGMENT}
`
